export default __webpack_public_path__ + "assets/images/2da863e5afd2800895053c12f3b675ec.png";